export default "__VITE_ASSET__Dat9E7u8__"